import '@/styles/global.css';

import React from 'react';
import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import NextProgressBar from 'nextjs-progressbar';
import Head from 'next/head';
import classNames from 'classnames';
import { GraphicLlCcFont } from '@/styles/fonts';
import Header from '@/components/Header';
import MainLayout from '@/layouts/MainLayout';
import TranslationProvider from '@/providers/TranslationProvider';
import LocaleProvider from '@/providers/LocaleProvider';
import AuthProvider from '@/providers/AuthProvider';
import LiveChatWidget from '@/components/LiveChatWidget/LiveChatWidget';

const Gdpr = dynamic(() => import('@/components/Gdpr'), { ssr: false });
const XAProvider = dynamic(() => import('@/providers/XAProvider'), { ssr: false });

export default function App({ Component, pageProps }: AppProps) {
  return (
    <LocaleProvider>
      <TranslationProvider>
        <AuthProvider>
          <XAProvider>
            <Head>
              <title>Xsolla Rewards</title>
            </Head>
            <MainLayout>
              <main
                className={classNames(GraphicLlCcFont.className, 'relative h-screen overflow-y-auto overflow-x-hidden')}
              >
                <Header />
                <NextProgressBar options={{ showSpinner: false }} />
                <Component {...pageProps} />
                <Gdpr />
                <LiveChatWidget />
              </main>
            </MainLayout>
          </XAProvider>
        </AuthProvider>
      </TranslationProvider>
    </LocaleProvider>
  );
}
